import { render, staticRenderFns } from "./RecruiterDashboardTab.vue?vue&type=template&id=28628c7c&"
import script from "./RecruiterDashboardTab.vue?vue&type=script&lang=js&"
export * from "./RecruiterDashboardTab.vue?vue&type=script&lang=js&"
import style0 from "./RecruiterDashboardTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports